import React, { useState } from 'react';
import { Container, Button, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaSearch, FaTrashAlt, FaPaperPlane } from 'react-icons/fa';
import '../../Styles/yellocalfcss/PendingInvoices.css';

const PendingInvoices = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState('');
  const [filters, setFilters] = useState({ invoiceId: '', student: '' });
  const [currentPage, setCurrentPage] = useState(1);

  const invoicesPerPage = 15;

  const invoices = [
    { id: 1785, student: 'Ashutosh', year: '2020-2021', demandDate: '2024-06-10', dueDate: '2024-06-10', amountTotal: 3700, amountPaid: 0, balance: 3700, status: 'Pending' },
    { id: 1786, student: 'John Doe', year: '2020-2021', demandDate: '2024-06-10', dueDate: '2024-06-10', amountTotal: 3800, amountPaid: 0, balance: 3800, status: 'Pending' },
    { id: 1787, student: 'Jane Smith', year: '2021-2022', demandDate: '2024-07-15', dueDate: '2024-07-15', amountTotal: 4000, amountPaid: 0, balance: 4000, status: 'Pending' },
    { id: 1788, student: 'Michael Lee', year: '2021-2022', demandDate: '2024-07-15', dueDate: '2024-07-15', amountTotal: 4100, amountPaid: 0, balance: 4100, status: 'Pending' },
    { id: 1789, student: 'Emily Davis', year: '2022-2023', demandDate: '2024-08-05', dueDate: '2024-08-05', amountTotal: 4200, amountPaid: 0, balance: 4200, status: 'Pending' },
    { id: 1790, student: 'David Brown', year: '2022-2023', demandDate: '2024-08-05', dueDate: '2024-08-05', amountTotal: 4300, amountPaid: 0, balance: 4300, status: 'Pending' },
    { id: 1791, student: 'Alice Green', year: '2023-2024', demandDate: '2024-09-01', dueDate: '2024-09-01', amountTotal: 4400, amountPaid: 0, balance: 4400, status: 'Pending' },
    { id: 1792, student: 'Chris White', year: '2023-2024', demandDate: '2024-09-01', dueDate: '2024-09-01', amountTotal: 4500, amountPaid: 0, balance: 4500, status: 'Pending' },
    { id: 1793, student: 'Olivia Black', year: '2024-2025', demandDate: '2024-09-25', dueDate: '2024-09-25', amountTotal: 4600, amountPaid: 0, balance: 4600, status: 'Pending' },
    { id: 1794, student: 'Ethan Hall', year: '2024-2025', demandDate: '2024-09-25', dueDate: '2024-09-25', amountTotal: 4700, amountPaid: 0, balance: 4700, status: 'Pending' },
    { id: 1795, student: 'Charlotte King', year: '2025-2026', demandDate: '2024-10-15', dueDate: '2024-10-15', amountTotal: 4800, amountPaid: 0, balance: 4800, status: 'Pending' },
    { id: 1796, student: 'James Carter', year: '2025-2026', demandDate: '2024-10-15', dueDate: '2024-10-15', amountTotal: 4900, amountPaid: 0, balance: 4900, status: 'Pending' },
    { id: 1797, student: 'Sophia Lee', year: '2026-2027', demandDate: '2024-11-20', dueDate: '2024-11-20', amountTotal: 5000, amountPaid: 0, balance: 5000, status: 'Pending' },
    { id: 1798, student: 'Jack Young', year: '2026-2027', demandDate: '2024-11-20', dueDate: '2024-11-20', amountTotal: 5100, amountPaid: 0, balance: 5100, status: 'Pending' },
    { id: 1797, student: 'Sophia Lee', year: '2026-2027', demandDate: '2024-11-20', dueDate: '2024-11-20', amountTotal: 5000, amountPaid: 0, balance: 5000, status: 'Pending' },
  ];

  const filteredInvoices = invoices.filter((invoice) => {
    return (
      (filters.invoiceId === '' || invoice.id.toString().includes(filters.invoiceId)) &&
      (filters.student === '' || invoice.student.toLowerCase().includes(filters.student.toLowerCase()))
    );
  });

  const totalPages = Math.ceil(filteredInvoices.length / invoicesPerPage);
  const currentInvoices = filteredInvoices.slice((currentPage - 1) * invoicesPerPage, currentPage * invoicesPerPage);

  const handleCollectFee = () => {
    setMessage('Navigate to Collect Fee page');
  };

  const handleBulkSend = () => {
    setMessage('Bulk Send initiated');
  };

  return (
    <div className="pending-invoices-main-container my-4">
      <Container fluid className="pending-invoices-fluid-wrapper">
        <div className="pending-invoices-header-area">
          <h1 className="pending-invoices-title-heading">Pending Fee Invoices</h1>
          <div className="pending-invoices-button-area">
            <Button className="pending-invoices-collect-button"onClick={() => navigate("/CollectFee")}>
                          Collect Fee
                        </Button>
            <Button onClick={handleBulkSend} className="pending-invoices-bulk-button">
              Bulk Send
            </Button>
          </div>
        </div>

        <div className="pending-invoices-filter-area">
          <div className="pending-invoices-filter-inputs-wrapper">
            <Form.Control
              type="text"
              placeholder="Invoice ID"
              value={filters.invoiceId}
              onChange={(e) => setFilters({ ...filters, invoiceId: e.target.value })}
              className="pending-invoices-filter-invoice-input"
            />
            <Form.Control
              type="text"
              placeholder="Student Name"
              value={filters.student}
              onChange={(e) => setFilters({ ...filters, student: e.target.value })}
              className="pending-invoices-filter-student-input"
            />
            <button type="button" class="btn custom-btn">Clear</button>
          </div>
        </div>

        {message && (
          <div className="pending-invoices-message-notification">
            {message}
          </div>
        )}

        <div className="pending-invoices-table-header-card">
          <div className="pending-invoices-grid-structure">
            <div className="pending-invoices-header-column">Sr.No</div>
            <div className="pending-invoices-header-column">Invoice ID</div>
            <div className="pending-invoices-header-column">Student</div>
            <div className="pending-invoices-header-column">Academic Year</div>
            <div className="pending-invoices-header-column">Demand Date</div>
            <div className="pending-invoices-header-column">Due Date</div>
            <div className="pending-invoices-header-column">Amount Total</div>
            <div className="pending-invoices-header-column">Amount Paid</div>
            <div className="pending-invoices-header-column">Balance</div>
            <div className="pending-invoices-header-column">Action</div>
          </div>
        </div>

        <div className="pending-invoices-data-cards-container">
          {currentInvoices.map((invoice, index) => (
            <div key={invoice.id} className="pending-invoices-individual-card">
              <div className="pending-invoices-grid-structure">
                <div className="pending-invoices-data-column">
                  {(currentPage - 1) * invoicesPerPage + index + 1}
                </div>
                <div className="pending-invoices-data-column">{invoice.id}</div>
                <div className="pending-invoices-data-column">{invoice.student}</div>
                <div className="pending-invoices-data-column">{invoice.year}</div>
                <div className="pending-invoices-data-column">{invoice.demandDate}</div>
                <div className="pending-invoices-data-column">{invoice.dueDate}</div>
                <div className="pending-invoices-data-column">{invoice.amountTotal}</div>
                <div className="pending-invoices-data-column">{invoice.amountPaid}</div>
                <div className="pending-invoices-data-column">{invoice.balance}</div>
                <div className="pending-invoices-data-column pending-invoices-action-column">
                  <button
                    className="pending-invoices-action-button btn-sm"
                    title="ViewInvoice"
                   onClick={() => navigate("/ViewInvoice")}>
                    <FaSearch />
                  </button>
                  <button
                    className="pending-invoices-action-button btn-sm"
                    title="Delete Invoice"
                    onClick={() => setMessage(`Delete Invoice ID: ${invoice.id}`)}
                  >
                    <FaTrashAlt />
                  </button>
                 <button
                    className="pending-invoices-action-button btn-sm"
                    title="SendInvoice"
                   onClick={() => navigate("/SendInvoice")}>
                      <FaPaperPlane />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="pending-invoices-pagination-text">
          Showing 1 - 15 of 15 items
        </div>
      </Container>
    </div>
  );
};

export default PendingInvoices;
